import WebApp from '@twa-dev/sdk';
import dayjs from 'dayjs';

import { isTMA } from '@/shared/helpers/is-tma';

import { setCookie } from '../../helpers';
import { logErrorMini } from '../../services/service-logger/lib/log-error-mini';
import { getTokenAuth } from './get-token-auth';
import { getTokenNoAuth } from './get-token-noauth';
import { getTokenPresaved } from './get-token-presaved';

const requestHash = () => {
  return new Promise<string>((resolve) => {
    const envHash = import.meta.env.VITE_DEV_HASH;
    if (envHash) {
      resolve(envHash);
    } else {
      const hash = prompt(
        'Enter the Telegram hash: copy(window.location.hash.slice(1)) or press the button on the dev page.'
      );

      resolve(hash || '');
    }
  });
};

const IS_DEV = import.meta.env.DEV;

export const getToken = async (initURLHash?: string): Promise<string> => {
  let token = null;

  if (!initURLHash && IS_DEV && !isTMA() && initURLHash !== undefined) {
    const hash = await requestHash();
    const { href } = window.location;

    localStorage.setItem('dev-hash', hash);

    const url = new URL(href);

    url.hash = hash;

    window.location.replace(url.toString());
  }

  try {
    const presavedToken = getTokenPresaved();

    if (presavedToken) {
      token = presavedToken;
    } else {
      const { initDataUnsafe: tgData, initData } = WebApp ?? {};
      const noUserData = !presavedToken && !tgData?.user && !tgData?.hash;
      token = noUserData ? await getTokenNoAuth() : await getTokenAuth(initData);
    }

    if (token) {
      setCookie('token', token, {
        secure: !IS_DEV,
        expires: IS_DEV ? dayjs().add(1, 'year').toDate() : undefined,
      });
    }
  } catch (err) {
    void logErrorMini(err as Error, 'getToken', {
      hasPresavedToken: !!getTokenPresaved(),
      hasTgData: !!WebApp?.initDataUnsafe,
    });
  }

  return token ?? '';
};
